import { AffiliateRegistrationForm } from '@/affiliates/registration-form';

$(document).ready(function() {

    AffiliateRegistrationForm.initFormValidation();

});